module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Archery Shoot Finder","short_name":"ASFinder","description":"Find archery shoots, tournaments, and events near you","start_url":"/","scope":"/","display":"fullscreen","orientation":"portrait","background_color":"#ffffff","theme_color":"#C2410C","lang":"en","categories":["sports","events","outdoors"],"icon":"src/images/logo-sticker-512.png","icon_options":{"purpose":"any maskable"},"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"e76ebb8153cfe48bbded0b8e8b7063b1"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[],"workboxConfig":{"runtimeCaching":[{"urlPattern":{},"handler":"NetworkFirst"}]}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
